module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vue-webpack-env-294.vue");


//////////////////
// WEBPACK FOOTER
// ./zh-CN/development/vue-webpack-env.md
// module id = 737
// module chunks = 204